export enum LeftPanelItem {
    HOME = 'insights-home',
    FAVOURITES = 'favourites',
    LIVEBOARDS = 'liveboards',
    ANSWERS = 'answers',
    ANSWER = 'search-data',
    CREATED_BY_ME = 'created-by-me',
    MONITOR_ALERTS = 'monitor-alerts',
    SPOTIQ_ANALYSIS = 'spotiq-analysis',
    HELP = 'insights-help',
    CHAT_WITH_SUPPORT = 'insights-chat-with-support',
    LIVEBOARD_SCHEDULES = 'liveboard-schedules',
    SPOTTER = 'spotter',
    COLLECTIONS = 'collections',
    APPS = 'apps',
}

export enum PerformanceMarkers {
    APP_START_TIME = 'appStartTime',
    APP_MOUNTED = 'app-mounted',
    INFO_CALL_REQUEST_STARTED = 'info-call-request-started',
    INFO_CALL_RESPONSE_STARTED = 'info-call-response-started',
    INFO_CALL_RESPONSE_ENDED = 'info-call-response-ended',
    INFO_CALL_COMPLETED = 'info-call-completed',
    APP_MOUNT = 'app-mount',
}
